import { createFileRoute } from '@tanstack/react-router';

import { ResetPasswordPage, resetPasswordSearchSchema } from '@/pages/reset-password';

export const Route = createFileRoute('/reset-password')({
    validateSearch: resetPasswordSearchSchema,
    component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
    const { token } = Route.useSearch();
    return <ResetPasswordPage token={token} />;
}
